module.exports = __webpack_public_path__ + "img/security-icon.d0289dc0.png";